import { useAtomValue, useSetAtom } from "jotai";

import { saveBarIsDirty, saveBarIsSaving } from "./app-save-bar.state";

export const useSaveBar = () => {
  const isDirty = useAtomValue(saveBarIsDirty);
  const isSaving = useAtomValue(saveBarIsSaving);

  const setIsDirty = useSetAtom(saveBarIsDirty);
  const setIsSaving = useSetAtom(saveBarIsSaving);

  return {
    isDirty,
    isSaving,
    setIsDirty,
    setIsSaving,
  };
};
